"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 17V6h-2V4h3.3744a1 1 0 0 1 .8351.45l5.2695 7.9999c.4379.6649-.0389 1.5501-.8351 1.5501h-3.3633l1.1121 1.3901A3.4846 3.4846 0 0 1 19 15c1.933 0 3.5 1.567 3.5 3.5S20.933 22 19 22s-3.5-1.567-3.5-3.5c0-.6228.1627-1.2077.4479-1.7144L15 15.6132V19H8.4646C8.2219 20.6961 6.7632 22 5 22c-1.933 0-3.5-1.567-3.5-3.5S3.067 15 5 15c.7262 0 1.4008.2212 1.96.5998C6.7746 14.687 5.9675 14 5 14H2v-3h6c1.1046 0 2 .8954 2 2v4h3zm6 3c-.8284 0-1.5-.6716-1.5-1.5S18.1716 17 19 17s1.5.6716 1.5 1.5S19.8284 20 19 20zM3.5 18.5c0 .8284.6716 1.5 1.5 1.5s1.5-.6716 1.5-1.5S5.8284 17 5 17s-1.5.6716-1.5 1.5z"
  })];
};

exports.default = _default;